import api from './client.js'

export const prizesAPI = {
  listCategories:   () => api.get('/prizes/categories'),
  getState:         () => api.get('/prizes/state'),
  listMyClaims:     () => api.get('/prizes/mine'),
  claim:            (prizeId) => api.post(`/prizes/claim/${prizeId}`),

  // Admin
  createCategory:   (data) => api.post('/prizes/admin/categories', data),
  updateCategory:   (id, data) => api.patch(`/prizes/admin/categories/${id}`, data),
  deleteCategory:   (id) => api.delete(`/prizes/admin/categories/${id}`),
  createPrize:      (data) => api.post('/prizes/admin/prizes', data),
  updatePrize:      (id, data) => api.patch(`/prizes/admin/prizes/${id}`, data),
  deletePrize:      (id) => api.delete(`/prizes/admin/prizes/${id}`),
  uploadImage:      (id, file) => {
    const fd = new FormData(); fd.append('file', file)
    return api.post(`/prizes/admin/prizes/${id}/image`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  openShop:         () => api.post('/prizes/admin/shop/open'),
  closeShop:        () => api.post('/prizes/admin/shop/close'),
  listClaims:       () => api.get('/prizes/admin/claims'),
  markHandover:     (id, notes) => api.post(`/prizes/admin/claims/${id}/handover`, { notes }),
  cancelClaim:      (id) => api.post(`/prizes/admin/claims/${id}/cancel`),
  resetClaims:      (prizeId) => api.delete(`/prizes/admin/prizes/${prizeId}/claims`),
  listArchive:      () => api.get('/prizes/admin/archive'),
  resetHistory:     () => api.delete('/prizes/admin/archive'),
}
